var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72.7 72.7",
    style: {
      enableBackground: "new 0 0 72.7 72.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#03A9F4;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M71.7,14.7c-2.6,1.2-5.5,2-8.5,2.3c3.1-1.8,5.4-4.7,6.5-8.1c-2.9,1.7-6,2.9-9.4,3.6c-2.7-2.8-6.5-4.6-10.8-4.6 c-8.2,0-14.8,6.6-14.8,14.6c0,1.1,0.1,2.3,0.4,3.3C22.9,25.2,12,19.4,4.7,10.5c-1.3,2.2-2,4.7-2,7.4c0,5.1,2.6,9.6,6.6,12.2 c-2.4-0.1-4.7-0.7-6.7-1.8c0,0,0,0.1,0,0.2c0,7.1,5.1,13,11.8,14.4c-1.2,0.3-2.5,0.5-3.9,0.5c-1,0-1.9-0.1-2.8-0.3 c1.9,5.8,7.3,10,13.8,10.2c-5.1,3.9-11.4,6.3-18.3,6.3c-1.2,0-2.4-0.1-3.5-0.2c6.5,4.1,14.3,6.6,22.6,6.6c27.2,0,42-22.3,42-41.7 c0-0.6,0-1.3-0.1-1.9C67.2,20.3,69.7,17.7,71.7,14.7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.9c4e72c3413a3f049d18752a94c60f61.svg";
export { ForwardRef as ReactComponent };